// extracted by mini-css-extract-plugin
export default {"EventSearchExpand":"EventSearch_EventSearchExpand__VFu+R","expand":"EventSearch_expand__UHBjm"};